import { LocaleSelect as PolangLocaleSelect, useTranslation } from '@compilorama/polang';
import { LocaleIcon } from '@src/base/icons/locale';
import translations from './locale-select.t.js';

export const LocaleSelect = ({ ...rest }) => {
  const { t, locale } = useTranslation(translations);

  return (
    <div className="p-locale-select-wrapper">
      <PolangLocaleSelect
        name="locale"
        aria-label={t('language')}
        {...rest}
      />
      <LocaleIcon locale={locale.code} />
    </div>
  );
};
